/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Alert_TitleInputs */



/**
* | output |
* | --- |
* | "Alert" |
*
* @param {Iframe_Remote_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_alert_title = /** @type {((inputs?: Iframe_Remote_Alert_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Alert_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alerte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alarm")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attenzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тревога")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alerta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("警报")
	if (locale === "ja") return /** @type {LocalizedString} */ ("警告")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चेतावनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alerta")
	return /** @type {LocalizedString} */ ("Alert")
});